import * as moment from "moment";
import _ from 'lodash';

import { Decimal } from 'decimal.js'; 

import Const from "./const";
const QueryString = require("query-string");

export function UrlSearch(key) {
	return QueryString.parse(window.location.search)[key];
}

export function IsAdmin(user) {
	if (!user || !user.Role) {
		return false;
	}
	return user.Role.includes(Const.USER_ROLE_ADMIN);
}

export function IsSupport(user) {
	if (!user || !user.Role) {
		return false;
	}
	return user.Role.includes(Const.USER_ROLE_SUPPORT);
}

export function GetStringIndexesOf(source, find) {
	if (!source) {
		return [];
	}
	if (!find) {
		return source.split("").map((_, i) => i);
	}
	const result = [];
	for (let i = 0; i < source.length; ++i) {
		if (source.substring(i, i + find.length) === find) {
			result.push(i);
		}
	}
	return result;
}

export function getChannelName(ChannelID) {
	const val = Const.ChannelInfo.filter(channel => channel.ChannelID === Number(ChannelID));
	return val.length ? val[0]["ChannelName"] : "未知";
}

export function GetConfigFieldValueToShow(field) {
	if (!field) {
		return "-";
	}
	let text = field.Value;
	if (field.Enum && field.Enum.length) {
		if (Array.isArray(field.Value)) {
			text = field.Value.map(v => {
				if (field.Enum.filter(e => e.Value === v).length) {
					return field.Enum.filter(e => e.Value === v)[0].Name;
				}
				return "";
			}).join(",");
		} else {
			if (field.Enum.filter(e => e.Value === field.Value).length) {
				text = field.Enum.filter(e => e.Value === field.Value)[0].Name;
			}
		}
	}
	if (field.Component === Const.COMPONENT_DATE && text) {
		text = moment.unix(Number(text)).format(Const.DATE_FORMAT);
	}
	if (field.Component === Const.COMPONENT_TIME && text) {
		text = moment.unix(Number(text)).format(Const.DATETIME_FORMAT);
	}
	return text || "-";
}

// 重保审核通过时间到当前时间
export function TimeToNow(time) {
	return moment(time).format("MM-DD") + "~" + moment().format("MM-DD");
}

export function GetProductName(productId, products) {
	let productName = "";
	products.forEach(product => {
		if (product.Id === productId) {
			productName = product.Name;
		}
	});
	return productName;
}

// 展示工单类型
export function GetTicketType(SignificantFault, IsBatch, IsMalfunction) {
	// 是否重大故障工单  SignificantFault 0 否  1 是
	// 是否批次单 IsBatch 0 普通单 1 批次单
	// 是否故障工单  IsMalfunction  0 默认 1 故障  2非故障
	// 是否普通工单
	if (SignificantFault && SignificantFault === 1) {
		return "重大故障工单";
	} else if (IsBatch === 1) {
		return "批次工单";
	} else if (IsMalfunction === 1) {
		return "故障工单";
	} else {
		return "普通工单";
	}
}

export function htmlConvert(htmlStr) {
	let reg = /<([a-z]+?)(?:\s+?[^>]*?)?>\s*?<\/\1>/gi;
	while (reg.test(htmlStr)) {
		return htmlStr.replace(reg, "");
	}
	return htmlStr;
}

// 获取百分比的格式，num1分子，num2分母，pointNum小数点保留位数
export const getPercentFormat = (num1, num2, pointNum = 2) => {
	if (num2) {
		// 保留两位小数
		const formatNum = ((num1 / num2) * 100).toFixed(pointNum);
		return formatNum + "%";
	}
	return (0).toFixed(pointNum) + "%";
};

// 获取数值千分位表现形式
export function getSthousandsFormatNum(num) {
	return (num + "").replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
}

// 格式化时间
export function formatDate(timestamp){
	return moment(timestamp*1000).format("YYYY-MM-DD HH:mm:ss")
}

// 运营平台统一除以 10000
// export const formatBillUnit = (bill) => {
// 	return (Math.floor((bill / 100) * 10000) / 10000).toFixed(4);
// };
export const formatBillUnit = (bill) => {
  const billPre = new Decimal(bill);
  return  billPre.div(10000).toFixed(6);
};

export const renderDeductTypes = (record) => {
  const Accounts = record.AccountInfo || [];
  const DeductTypes = Accounts.map(item => item.DeductType);
  const uniqDeductTypes = _.uniq(DeductTypes);
  if (uniqDeductTypes.length === 0) {
    return "-"
  } else {
    let deductName = ""
    uniqDeductTypes.forEach((item, index) => {
      deductName += Const.DeductNumberType[item]
      if (index < uniqDeductTypes.length - 1) {
        deductName += "/"
      }
    })
    return deductName
  }
}

// 通过CompanyId获取公司名称：公司名称-公司ID
export function renderCompanyCNameByCompanyId(CompanyId, customerList, renderCName) {
  const customerOptions =
    customerList && customerList.length > 0 ? customerList : [];
  const customer = customerOptions.find((item) => item.CompanyId === CompanyId);
  if (renderCName) {
    return customer ? renderCName(customer) : CompanyId;
  }
  return customer
    ? `${customer.CompanyName}(${customer.CompanyId})-${customer.UserEmail}-${customer.Remark}`
    : CompanyId;
}

// 通过CompanyId获取公司名称：公司名称-公司ID
export function renderOrgCNameByOrgId(OrganizationId, customerList, renderCName) {
	const customerOptions =
	  customerList && customerList.length > 0 ? customerList : [];
	const customer = customerOptions.find((item) => item.OrganizationId === OrganizationId);
	if (renderCName) {
	  return customer ? renderCName(customer) : OrganizationId;
	}
	return customer
	  ? `${customer.OrganizationName}(${customer.OrganizationId})-${customer.UserEmail}-${customer.Remark}`
	  : OrganizationId;
  }